jQuery(($)=>{
   let selector: string = 'equalizer-component';
   let elementSelector: string = 'equalizer-element';

   let components = $(`[${selector}]`);

   components.each((key, component: any)=>{
       component = $(component);
       let elements = (component as unknown as JQuery).find(`[${elementSelector}]`);
       let maxHeight = 0;

       elements.each((k, element: any)=>{
           element = $(element);
          let height = element[0].getBoundingClientRect().height;

          if(height > maxHeight)
          {
              maxHeight = height;
          }
       });
       elements.height(maxHeight);
   });
});